import { ICommandBase } from "@Pages/cqrs";

export class DeleteRequestPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Pages.Commands.DeleteRequestPageCommandV1, TCh.Domain.Pages';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, pageId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = pageId.toString();
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Pages.Commands.DeleteRequestPageCommandV1, TCh.Domain.Pages';
	}
}

export class CreateRequestPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Pages.Commands.CreateRequestPageCommandV1, TCh.Domain.Pages';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Name: string; 

	constructor(workspaceId: number, projectId: number, pageId: number, name: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = pageId.toString();
		this.Name = name;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Pages.Commands.CreateRequestPageCommandV1, TCh.Domain.Pages';
	}
}

export class CloneRequestPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Pages.Commands.CloneRequestPageCommandV1, TCh.Domain.Pages';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	CloneName: string;

	constructor(workspaceId: number, projectId: number, pageId: number, cloneName: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = pageId.toString();
		this.CloneName = cloneName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Pages.Commands.CloneRequestPageCommandV1, TCh.Domain.Pages';
	}
}

export class UpdateRequestPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Pages.Commands.UpdateRequestPageCommandV1, TCh.Domain.Pages';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Name: string;
	Description: string;
	LogoUrl: string;
	ContentHtml: string;
	FormId: number;

	constructor(workspaceId: number, projectId: number, pageId: number, name: string, description: string, logoUrl: string, contentHtml: string, formId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = pageId.toString();
		this.Name = name;
		this.Description = description;
		this.LogoUrl = logoUrl;
		this.ContentHtml = contentHtml;
		this.FormId = formId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Pages.Commands.UpdateRequestPageCommandV1, TCh.Domain.Pages';
	}
}

